import AgencyMaintainService from "../../agency_maintain/service";
import {message} from "antd";

export const SYS_MGT_ROLE_LIST_IS_LOADING = "SYS_MGT_ROLE_LIST_IS_LOADING"; // 角色列表是否加载中
export const SYS_MGT_GET_ROLE_LIST = "SYS_MGT_GET_ROLE_LIST"; // 获取角色列表
export const SYS_MGT_SET_ROLE_DRAWER_INFO = "SYS_MGT_SET_ROLE_DRAWER_INFO"; // 设置模态框信息
export const SYS_MGT_ROLE_SET_SEARCH_PARAMS = "SYS_MGT_ROLE_SET_SEARCH_PARAMS"; // 设置查询参数
export const SYS_MGT_ROLE_SET_DRAWER_INFO = "SYS_MGT_ROLE_SET_DRAWER_INFO"; // 设置抽屉信息
export const SYS_MGT_ROLE_EDIT_ROLE = "SYS_MGT_ROLE_EDIT_ROLE"; // 编辑角色
/**
 * 获取角色列表
 * @param params 请求参数
 */
export const getRoleList = (params) => {
    return dispatch => {
        dispatch(setRoleTableIsLoading(true));
        AgencyMaintainService.sysMgtRoleService.getRoleList(params).then(json => {
            if(json.code == 0){
                dispatch({
                    type: SYS_MGT_GET_ROLE_LIST,
                    list: json.data.pageList,
                    total: json.data.totalCount
                })
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("获取角色列表失败:" + e);
            message.error("获取列表失败");
        }).then(() => dispatch(setRoleTableIsLoading(false)))
    }
}

/**
 * 编辑角色
 */
export const addRole = (roleInfo) => {
    return (dispatch, getState) => {
        dispatch(setRoleDrawerInfo({isLoading: true}));
        const orgNo = getState().userData.userInfo.orgNo;
        AgencyMaintainService.sysMgtRoleService.addRole({...roleInfo, orgNo: orgNo}).then(json => {
            if(json.code == 0){
                const searchParams = getState().agencyMaintainData.roleData.searchParams;
                dispatch(getRoleList(searchParams));
                //dispatch
                dispatch(setDrawerInfo({visible: false}));
                message.success("新增成功");
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("新增角色失败:" + e);
            message.error("新增角色失败")
        }).then(() => dispatch(setRoleDrawerInfo({isLoading: false})))
    }
}

/**
 * 编辑角色
 * @param role 角色信息
 */
export const editRole = (role) => {
    return (dispatch) => {
        dispatch(setRoleDrawerInfo({isLoading: true}));
        AgencyMaintainService.sysMgtRoleService.editRole(role).then(json => {
            if(json.code == 0){
                dispatch({
                    type: SYS_MGT_ROLE_EDIT_ROLE,
                    role: json.data
                })
                dispatch(setDrawerInfo({visible: false}));
                message.success("修改成功");
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("编辑角色异常:" + e);
            message.error("修改失败");
        }).then(() => dispatch(setRoleDrawerInfo({isLoading: false})))
    }
}

/**
 * 删除角色
 * @param roleId 角色id
 */
export const deleteRole = (roleId) => {
    return (dispatch, getState) => {
        message.loading({content: "删除中...", key: roleId, duration: 0});
        AgencyMaintainService.sysMgtRoleService.deleteRole(roleId).then(json => {
            if(json.code == 0){
                message.success({content: "删除成功", key: roleId});
                // 刷新查询列表
                const searchParams = getState().agencyMaintainData.roleData.searchParams
                dispatch(getRoleList(searchParams))
            }else{
                message.error({content: json.msg, key: roleId});
            }
        }).catch(e => {
            console.error("删除用户异常:" + e);
            message.error({content: "删除失败", key: roleId});
        })
    }
}

/**
 * 设置查询参数
 * @param params 查询参数
 */
export const setSearchParams = (params) => {
    return {
        type: SYS_MGT_ROLE_SET_SEARCH_PARAMS,
        data: params
    }
}

/**
 * 设置抽屉信息
 */
export const setDrawerInfo = (drawerInfo) => {
    return {
        type: SYS_MGT_ROLE_SET_DRAWER_INFO,
        drawerInfo: drawerInfo
    }
}

/**
 * 设置角色列表是否加载中
 */
const setRoleTableIsLoading = (isLoading) => {
    return {
        type: SYS_MGT_ROLE_LIST_IS_LOADING,
        isLoading: isLoading
    }
}

/**
 * 设置角色抽屉信息
 */
const setRoleDrawerInfo =  (data) => {
    return {
        type: SYS_MGT_SET_ROLE_DRAWER_INFO,
        data: data
    }
}
